import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Link,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import { Stack } from '@mui/system';
import { fetchPost } from '../api/common';
import { isMobile } from 'react-device-detect';

type PropTypes = {
  close: () => void;
  open: boolean;
  profileId: string;
};

export const TournamentSignUpDialog = ({
  close,
  open,
  profileId,
}: PropTypes) => {
  const theme = useTheme();

  const handleSignUpClick = async (signup: number) => {
    const res = await fetchPost('/profile/tournament-signup', {
      profileId: profileId,
      tournamentSignUp: signup,
    });
    if (res.message) {
      close();
    }
  };

  return (
    <Dialog open={open} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Stack spacing={2} mt={2} mb={2}>
          <Typography variant="h5" textAlign={'center'}>
            Beta tournament #5 on August 28th, 9PM ET
          </Typography>
          <Stack>
            <Typography
              textAlign={'center'}
              sx={{ color: theme.palette.primary.light }}
            >
              Est tourney time ~90 min to the championship.
            </Typography>
            <Typography
              textAlign={'center'}
              sx={{ color: theme.palette.primary.light }}
            >
              This is a poll for tracking potential headcount, anyone can show
              up and play the day of!
            </Typography>
            <Typography
              textAlign={'center'}
              sx={{ color: theme.palette.primary.light }}
            >
              If you've never seen a PAR tournament, this was{' '}
              <Link
                href="https://www.youtube.com/watch?v=U_5deQB2jl8"
                target={'_blank'}
                sx={{ color: theme.palette.ranked.main }}
              >
                Beta Tourney #3
              </Link>
            </Typography>
          </Stack>
          <Typography
            variant="h6"
            textAlign={'center'}
            fontWeight={600}
            sx={{ color: theme.palette.secondary.light }}
          >
            Will you play?
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ width: '100%', height: '100%' }}>
        <Stack
          direction={isMobile ? 'column' : 'row'}
          spacing={4}
          sx={{ display: 'flex', justifyContent: 'center' }}
        >
          <Tooltip title="I plan to participate" placement="top">
            <Card sx={{ maxWidth: 300, flex: 1 }}>
              <CardActionArea onClick={() => handleSignUpClick(1)}>
                <CardMedia
                  component="img"
                  height="300"
                  image="https://media.giphy.com/media/iKBAAfYNDu1dowhnEj/giphy.gif"
                  alt="imin"
                  sx={{
                    borderRadius: '5px',
                    border: '1px solid',
                    borderColor: theme.palette.primary.main,
                  }}
                />
              </CardActionArea>
            </Card>
          </Tooltip>
          <Tooltip title="Maybe, if I'm free" placement="top">
            <Card sx={{ maxWidth: 300, flex: 1 }}>
              <CardActionArea onClick={() => handleSignUpClick(2)}>
                <CardMedia
                  component="img"
                  height="300"
                  image="https://media.giphy.com/media/ndrNCM4RRAiCx8PfDC/giphy.gif"
                  alt="maybe"
                  sx={{
                    borderRadius: '5px',
                    border: '1px solid',
                    borderColor: theme.palette.primary.main,
                  }}
                />
              </CardActionArea>
            </Card>
          </Tooltip>
          <Tooltip title="I'll watch" placement="top">
            <Card sx={{ maxWidth: 300, flex: 1 }}>
              <CardActionArea onClick={() => handleSignUpClick(3)}>
                <CardMedia
                  component="img"
                  height="300"
                  image="https://media.giphy.com/media/L0HIznJ2hn4WndRshY/giphy.gif"
                  alt="nexttime"
                  sx={{
                    borderRadius: '5px',
                    border: '1px solid',
                    borderColor: theme.palette.primary.main,
                  }}
                />
              </CardActionArea>
            </Card>
          </Tooltip>
          <Tooltip title="I don't plan on participating" placement="top">
            <Card sx={{ maxWidth: 300, flex: 1 }}>
              <CardActionArea onClick={() => handleSignUpClick(4)}>
                <CardMedia
                  component="img"
                  height="300"
                  image="https://media.giphy.com/media/X8baci2TMGEcE/giphy.gif"
                  alt="nexttime"
                  sx={{
                    borderRadius: '5px',
                    border: '1px solid',
                    borderColor: theme.palette.primary.main,
                  }}
                />
              </CardActionArea>
            </Card>
          </Tooltip>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
